import React, { forwardRef } from 'react';
const CardImage = forwardRef(function CardImage({ testId = 'store-card-image', children, ...otherProps }, ref) {
    return (React.createElement("div", Object.assign({ ref: ref, "data-card-image": true, "data-testid": testId }, otherProps), children));
});
export default CardImage;
//# sourceMappingURL=CardImage.js.map